<svg width="30" height="29" style="margin-top: 2px;" class="tree-part-{{$id}}">
    <path d="M 0 15 L 30 15"/>
    <circle cx="15" cy="15" r="0" style="stroke: none;"/>
</svg>